module.exports = __webpack_public_path__ + "assets/img/ski_race.6c28a3e7.jpg";